export const MAX_GRID_WIDTH = 500;
export const MAX_GRID_HEIGHT = 500;

function parseLifeRule(rule) {
  const match = rule.match(/^B(\d*)\/S(\d*)$/i);
  if (!match) {
    throw new Error(
      `Invalid rule format: ${rule}. Expected format like "B3/S23"`
    );
  }

  const born = new Set(match[1].split("").map(Number));
  const live = new Set(match[2].split("").map(Number));

  return { born, live };
}

export const DEFAULT_RULE = "B3/S23";
export const HIGH_LIFE = "B36/S23";
export const DAY_NIGHT = "B3678/S34678";
export const SEEDS = "B2/S";
export const LIFE_WITHOUT_DEATH = "B3/S012345678";

export const RULES = [
  { name: "Original", rule: DEFAULT_RULE },
  { name: "Life Without Death", rule: LIFE_WITHOUT_DEATH },
  { name: "Day & Night", rule: DAY_NIGHT },
  { name: "High Life", rule: HIGH_LIFE },
  { name: "Seeds", rule: SEEDS },
];

export class STATE {
  static DEAD = 1;
  static ALIVE = 2;
}

class LifeSimulator {
  constructor() {
    this.gridA = this.createGrid();
    this.gridB = this.createGrid();
    const defaultRule = parseLifeRule(DEFAULT_RULE);
    this.bornIf = defaultRule.born;
    this.liveIf = defaultRule.live;

    // this.gridA[250][250] = STATE.ALIVE;
    // this.gridA[250][251] = STATE.ALIVE;
    // this.gridA[251][250] = STATE.ALIVE;
    // this.gridA[251][251] = STATE.ALIVE;

    this.gridAIsActive = true;
  }

  setRule(ruleString) {
    const rule = parseLifeRule(ruleString);
    this.bornIf = rule.born;
    this.liveIf = rule.live;
  }

  size() {
    return { width: MAX_GRID_WIDTH, height: MAX_GRID_HEIGHT };
  }

  clear() {
    this.gridA = this.createGrid();
    this.gridB = this.createGrid();
  }

  createGrid() {
    // current state, next state
    return Array.from({ length: MAX_GRID_HEIGHT }, () =>
      Array.from({ length: MAX_GRID_WIDTH }, () => STATE.DEAD)
    );
  }

  getActiveCell(x, y) {
    return this.gridAIsActive ? this.gridA[y][x] : this.gridB[y][x];
  }

  invertCell(value) {
    return value === STATE.DEAD ? STATE.ALIVE : STATE.DEAD;
  }

  setActiveCell(x, y, state) {
    const grid = this.gridAIsActive ? this.gridA : this.gridB;
    grid[y][x] = state;
  }

  flipActiveCell(x, y) {
    const grid = this.gridAIsActive ? this.gridA : this.gridB;
    grid[y][x] = grid[y][x] === STATE.DEAD ? STATE.ALIVE : STATE.DEAD;
  }

  setNextCell(x, y, state) {
    const nextGrid = this.gridAIsActive ? this.gridB : this.gridA;
    nextGrid[y][x] = state;
  }

  assignNextState(x, y) {
    const currentState = this.getActiveCell(x, y);
    let liveNeighbors = 0;
    for (let dx = -1; dx <= 1; dx++) {
      for (let dy = -1; dy <= 1; dy++) {
        if (dx === 0 && dy === 0) continue;
        const localX = x + dx;
        const localY = y + dy;
        if (
          localX < 0 ||
          localX >= MAX_GRID_WIDTH ||
          localY < 0 ||
          localY >= MAX_GRID_HEIGHT
        )
          continue;
        const neighborState = this.getActiveCell(localX, localY);
        if (neighborState === STATE.ALIVE) liveNeighbors++;
      }
    }

    let nextState = null;
    if (currentState === STATE.DEAD) {
      nextState = this.bornIf.has(liveNeighbors) ? STATE.ALIVE : STATE.DEAD;
    } else if (currentState === STATE.ALIVE) {
      nextState = this.liveIf.has(liveNeighbors) ? STATE.ALIVE : STATE.DEAD;
    }
    this.setNextCell(x, y, nextState);
  }

  step() {
    for (let x = 0; x < MAX_GRID_WIDTH; x++) {
      for (let y = 0; y < MAX_GRID_HEIGHT; y++) {
        this.assignNextState(x, y);
      }
    }
    this.gridAIsActive = !this.gridAIsActive;
  }
}

export default LifeSimulator;
